"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchTemplates = exports.templatesInfoMap = void 0;
const domain_1 = require("@home-health-notify/domain");
const react_1 = require("react");
const useLatestAsyncEffect_1 = require("./useLatestAsyncEffect");
exports.templatesInfoMap = {
    [domain_1.TEMPLATES.SOC]: { label: "Start of Care (SOC)" },
    [domain_1.TEMPLATES.TRANSFER_OASIS]: { label: "Transfer OASIS" },
    [domain_1.TEMPLATES.ROC]: { label: "Resumption of Care (ROC)" },
    [domain_1.TEMPLATES.REVISIT]: { label: "Revisit" },
    [domain_1.TEMPLATES.DC_SUMMARY]: { label: "Discharge Summary" },
    [domain_1.TEMPLATES.DC_OASIS]: { label: "Discharge OASIS" },
    [domain_1.TEMPLATES.AIDE_FIRST_VISIT]: { label: "Aide First Visit" },
    [domain_1.TEMPLATES.AIDE_LAST_VISIT]: { label: "Aide Last Visit" },
    [domain_1.TEMPLATES.RECERT]: { label: "Recertification" },
    [domain_1.TEMPLATES.EVAL]: { label: "Evaluation" },
    [domain_1.TEMPLATES.ADD_DELETE_DISCIPLINE]: { label: "Add/Delete Disciplines" },
    [domain_1.TEMPLATES.HANDS_OFF]: { label: "Hands Off" },
    [domain_1.TEMPLATES.VITAL]: { label: "Vital Signs" },
    [domain_1.TEMPLATES.SCHEDULE_SOC]: { label: "Schedule SOC" },
    [domain_1.TEMPLATES.SCHEDULE_EVAL]: { label: "Schedule Evaluation" },
    [domain_1.TEMPLATES.MISSED_VISIT]: { label: "Missed Visit" },
    [domain_1.TEMPLATES.SCHEDULE_FIRST_VISIT]: { label: "Schedule First Visit" },
    [domain_1.TEMPLATES.UPDATE_SERVICE_TEMPLATE]: { label: "Update Service Template" },
    [domain_1.TEMPLATES.TELE_MEDICINE]: { label: "Telemedicine" },
    [domain_1.TEMPLATES.SCHEDULE_ROC]: { label: "Schedule ROC" },
    [domain_1.TEMPLATES.SCHEDULE_CANCEL_VISIT]: { label: "Schedule/Cancel Visit" },
};
const useFetchTemplates = (selectedRole, chat) => {
    const [isTemplateLoading, setIsTemplateLoading] = (0, react_1.useState)(false);
    (0, useLatestAsyncEffect_1.useLatestAsyncEffect)((checkIfLatest, abortContext) => __awaiter(void 0, void 0, void 0, function* () {
        if (!chat)
            return;
        setIsTemplateLoading(true);
        try {
            yield chat.fetchTemplates(selectedRole, abortContext);
        }
        finally {
            if (checkIfLatest())
                setIsTemplateLoading(false);
        }
    }), [chat, selectedRole]);
    return {
        isTemplateLoading,
        templatesInfoMap: exports.templatesInfoMap,
    };
};
exports.useFetchTemplates = useFetchTemplates;
